import React from "react";
import InteractiveMapPage from "../interactiveMapPage";
import gibbonsTreehouseImage from "../../3-assets/images/laos/gibbons/treehouse.jpg";
import gibbonsMeImage from "../../3-assets/images/laos/gibbons/me.jpg";
import gibbonsWorkerImage from "../../3-assets/images/laos/gibbons/worker.jpg";
import luangPrabangMeImage from "../../3-assets/images/laos/luang prabang/me.jpg";
import luangPrabangViewImage from "../../3-assets/images/laos/luang prabang/view.jpg";
import luangPrabangMonksImage from "../../3-assets/images/laos/luang prabang/monks.jpg";
import luangPrabangMarketImage from "../../3-assets/images/laos/luang prabang/market.jpg";
import kuangSiImage from "../../3-assets/images/laos/kuang si/kuang-si-waterfall.jpg";
import phaDaengImage from "../../3-assets/images/laos/nong khiaow/pha-daeng-peak.jpg";
import peakCoffeeImage from "../../3-assets/images/laos/nong khiaow/peak-coffee.jpg";
import caveDavidImage from "../../3-assets/images/laos/nong khiaow/pha-kuang-cave.jpg";
import caveClaraImage from "../../3-assets/images/laos/nong khiaow/pha-kuang-clara.jpg";
import caveFeetImage from "../../3-assets/images/laos/nong khiaow/cave-feet.jpg";
import roadImage from "../../3-assets/images/laos/nong khiaow/road.jpg";
import junglePartyImage from "../../3-assets/images/laos/jungle party/butt.jpg";
import mushroomDrinkImage from "../../3-assets/images/laos/jungle party/mushrooms.jpg";
import riceFieldImage from "../../3-assets/images/laos/rice fields/bridge.jpg";
import vangViengImage from "../../3-assets/images/laos/vang vieng/road.jpg";
import phaNgernImage from "../../3-assets/images/laos/pha ngern/benji.jpg";
import blueLagoonImage from "../../3-assets/images/laos/blue lagoon/jenna.jpg";

const events = [
  {
    images: [gibbonsTreehouseImage, gibbonsMeImage, gibbonsWorkerImage],
    paragraphs: [
      "The Gibbons Experience is a network of treehouses and zip-lines in rural, rural Laos. The national park it’s nested in doesn’t even show up on google maps. You need to stay overnight in Huay Xai, bus two hours to a rural town, trek with all your bags another two hours up into the mountain, and zip-line down into your first treehouse. It’s exhausting. ",
      "The views are amazing, and although their is a whole lot of hiking during the day, it’s manageable. We zip-lined more than 30 times over three days, including one that was over 1200 feet long. Wild.",
      "The hard part is when you’re not moving. You’re pretty much sleeping outside in the jungle, and everything wants to bite you. There’s tons of wasps, biting ants (they come and go in swarms), and scarily big spiders. While napping I rolled over onto to a bee and got stung, and I’ve woken up covered in bite-y ants a whole bunch.",
      "It’s gritty, but a great experience to do once, and only once."
    ],
    location: {
      name: "Gibbons Experience",
      coordinates: {
        lat: 20.661926,
        lng: 100.717277
      }
    }
  },
  {
    images: [
      luangPrabangMonksImage,
      luangPrabangMeImage,
      luangPrabangViewImage,
      luangPrabangMarketImage
    ],
    paragraphs: [
      "Luang Prabang is the former royal capital of Laos and a UNESCO World Heritage site. It lies at the intersection between two big rivers. It’s also not an unmarked jungle in the middle of nowhere, which is a plus. ",
      "We arrived by tuk tuk around 5am to be surprised that most people were up too. Each day the town’s monks walk in a line through the city, collecting donations of cooked rice from locals waiting for them on the street. Sometimes you’ll find small children with empty baskets, waiting for some monks to share their donated rice with them. This has been going on every day for over 700 years, and it feels like the whole city partakes. The silence feels surreal since nobody is allowed to talk to or touch the monks.",
      "Luang Prabang is unlike any other city I’d visited in Laos. It’s much more developed, with a mixture of cheap markets and nicer restaurants. It’s more tourist-friendly than rural Laos, but in a good way. You won’t find Starbucks or any other western brand, but the French-colonial influence is unmistakable. I felt they struck a good balance between modernizing the city, while still maintaining its culture in a respectful and genuine way. The town bans trucks and other large vehicles from driving through its center, making it super friendly and peaceful to explore.",
      "At the heart of the town is a huge market. It’s so good and cheap, it was hard to eat anywhere else. Utopia bar is also a great spot for meeting other backpackers, and everyone goes bowling (of all things) after the bar closes at 11:30.",
      "I spent 4 or 5 days here, the longest I’ve stayed in any city."
    ],
    location: {
      name: "Luang Prabang",
      coordinates: {
        lat: 19.8834,
        lng: 102.1347
      }
    }
  },
  {
    images: [kuangSiImage],
    paragraphs: [
      "Kuang Si Waterfall is a network of pools down a mountain stemming from one massive waterfall at it’s top. I felt I’d seen all there was to great waterfalls after traveling through Bali, but the water here is the brightest turquoise I’d seen and worth the trip.",
      "There’ a hike to the top of the waterfall, but the memorable part is swimming in one of the pool plateaus. There’s fish in some of the bigger pools, and they nibbled at my feet while I was washing off my flip-flops. I didn’t know the feet-cleaning fish is part of the draw to Kuang Si and jumped straight out of the pool."
    ],
    location: {
      name: "Kuang Si Waterfall",
      coordinates: {
        lat: 19.7495,
        lng: 101.9919
      }
    }
  },
  {
    images: [roadImage],
    paragraphs: [
      "Nong Khiaw is a rural, rural town four hours north of Luang Prabang. The drive wouldn’t have been that tough if we hadn’t stuffed 15 people into a 11 person van. Worth it, but don’t expect comfort.",
      "The town feels like they’ve done little to nothing to appeal to tourists, which is the core of its charm. There were only a handful of places you could stay, and tough luck if you wanted to get food nearby; all that’s around the hostels are the locals’ homes. Food is a 15 walk away to its maybe a dozen family-owned restaurants.",
      "The nature around the town is phenomenal, and you really feel like you’re experiencing the real Laos."
    ],
    location: {
      name: "Nong Khiaw",
      coordinates: {
        lat: 20.571,
        lng: 102.6116
      }
    }
  },
  {
    images: [caveDavidImage, caveClaraImage, caveFeetImage],
    paragraphs: [
      "I’ve done my fair share of cave treks. Pha Kuang is not a cave trek: it’s a cave challenge. Unlike a cave trek, there are no tour guides, minimal signage, and we came out covered head-to-toe in mud.",
      "This cave is where hundreds of Lao sheltered for 9 years during the Secret War in the Vietnam War era. We found dozens of rusty aluminum food cans and writing on the walls. Part of the cave was used as a hospital back then, but it’s hard to fathom anybody living down there.",
      "Early on you reach the first bottleneck to the challenge: a 0.3m by 0.5m hole that you (and your backpack) need to squeeze through. We tried, gave up, tried again, gave up, tried again, and finally managed to squeeze through. There were parts where I was on my stomach, inching myself forward by using only my arms. It felt like what I’d expect Navy seals might do in training. After each squeeze into a new cavity, I half-expected to find the skeleton of some traveler who wasn’t able to make it back.",
      "Almost two hours later, we reached the end of the ‘safe’ part of the trek without finding any skeletons (woo). It was hard to know if we were on the actual path, or very lost, but the series of 10 meter to 20 meter steep, muddy declines marked by “DANGER” signs let us know we were in the right place. The signs did not say “DO NOT GO”, so we saw it as a challenge and went down all of them. Getting back up was especially tough, and our friend Clara had to go barefoot to get a better grip.",
      "Later we found out that’s a no-go-zone. We sprained some ankles, cut ourselves, and were covered in mud. It was the most mentally tough and rewarding trek I’d done."
    ],
    location: {
      name: "Pha Kuang Cave",
      coordinates: {
        lat: 20.590234,
        lng: 102.59185
      }
    }
  },
  {
    images: [phaDaengImage, peakCoffeeImage],
    paragraphs: [
      "This hike is not easy, so all the locals recommend doing it as a sunrise or sunset hike when it’s the most cool. We woke up at 4 for the sunrise hike, but walked 30 minutes down the wrong path right next to the trailhead (it was dark) and missed the beginning.",
      "I wore my trusty elephant pants, which audibly ripped no less than 7 times on the way up, and a half dozen more times on the way down. It depends on your definition of pants, but you could argue I was not wearing pants on the way back to the hostel.",
      "Regardless, Pha Daeng was one of the best viewpoints I’d seen. Once we got to the top, a bunch of Israeli’s making their own coffee and banana-oreo sandwiches invited us to eat with them. It was hard to leave, and the only other viewpoint that has come close was Mount Batur in Bali."
    ],
    location: {
      name: "Pha Daeng Peak",
      coordinates: {
        lat: 20.571788,
        lng: 102.625866
      }
    }
  },
  {
    images: [vangViengImage],
    paragraphs: [
      "Vang Vieng is more of a party city than the other towns we stayed in. Our hostel was a proper party hostel, and the most popular activity in the city is a half day long tubing party down-river, stopping at bars for often free alcohol. If you see past all the party culture, there’s tons of hiking to do around town, and the views right outside the city are phenomenal. We rented bikes, but it get’s a little complicated when sharing the road with a small army of cows. When it comes to the rules of the road, the cow always has the right of way. Always."
    ],
    location: {
      name: "Vang Vieng",
      coordinates: {
        lat: 18.9501,
        lng: 102.4438
      }
    }
  },
  {
    images: [phaNgernImage],
    paragraphs: [
      "By the time we biked to the trailhead for a sunset hike, the trail had been closed for almost an hour. The ticket-people tried to convince us it was a bad idea to go up, but we weren’t going to have biked 30 minutes just to give up. Plus, we felt we could do the 40 minute hike up and down fast before it got too dark.",
      "Whoever said that hike takes 40 minutes is a filthy liar. The trail starts off clear, with some signage here and there, but near halfway, it’s hard to tell there even is a trail. There are parts where you are literally climbing. Going as fast as we could, it took us around 70 minutes, making it just for the end of the sunset.",
      "We thought it was really tough sprinting up the mountain, but it was way harder going down. It turned pitch black real fast, and it took us near two hours to scale back down. The really big insects come out at night, including an extended family of giant millipedes-looking-things the size of my forearm. David noted “This is where the zoos must find the wacky insects they put in cages.” The lack of a clear trail, and super steep, wobbly rocks made it especially tough.",
      "By the time we made it down, we were in a rainstorm, and the guys who live at the trailhead to collect tickets thought we were the funniest thing in the world. They sold us water for double the normal price in the rest of Laos, and at that point, I was more than happy to pay for it.",
      "There were some clear landmarks we never saw on our way back down. Maybe it was because it was dark, or maybe we scaled the mountain on a non-path. We really don’t know."
    ],
    location: {
      name: "Pha Ngern Mountain",
      coordinates: {
        lat: 18.916338,
        lng: 102.413108
      }
    }
  },
  {
    images: [blueLagoonImage],
    paragraphs: [
      "There’s a bunch of blue lagoons, name with increasing numbers the farther away from town. We were told the more remote ones are more interesting, but you can only swim in a few closer to town. This one felt crowded and a bit touristy, but you don’t have many opportunities to go in the water in Laos. They also have a rope swing and a slide, which is a total game-changer. We had a great time. "
    ],
    location: {
      name: "Blue Lagoon 1",
      coordinates: {
        lat: 18.926787,
        lng: 102.395448
      }
    }
  },
  {
    images: [riceFieldImage],
    paragraphs: [
      "I’m not sure what to call this. David found this picture on Google images, and asked around until we figured out it’s part of a villa. Technically, non-guests aren’t allowed over there, but I kept taking photos until we were kicked out. In the background, all that haze was a big rainstorm that soaked us a few minutes later. "
    ],
    location: {
      name: "Rice Field Bridge",
      coordinates: {
        lat: 18.921878,
        lng: 102.443531
      }
    }
  },
  {
    images: [mushroomDrinkImage, junglePartyImage],
    paragraphs: [
      "The jungle party was heavily marketed around town and our hostel especially. It’s definitely not in the jungle, but it is a really big bar-complex a tuk-tuk drive outside of town. I feel in peak season it would have been a blast, but it felt like there was too much space for too few people. They also sell shroom-shakes if you’re into it. When I started snapping pictures, some english guys wanted me to take pictures of them. We left after an 90 minutes or so. ",
      "Around 2am I got an instagram dm, “Yo you got a photo of my ass ahah can you send it.” Swipe with caution."
    ],
    location: {
      name: "Jungle Party",
      coordinates: {
        lat: 18.947298,
        lng: 102.443955
      }
    }
  },
  {
    images: [],
    paragraphs: [
      "Tubing is the most popular activity in Vang Vieng. As of a few years ago, tubers would stop at dozens of bars on the way down, often getting free alcohol. That led to dozens of drownings each year, and now only 3 bars are open on the water.",
      "The start of the the half day float is 30 or so minutes outside of town. By the time we got there, we were in the middle of the worst thunderstorm I’d seen in a long time. It felt there was lightning every few moments, and they felt way closer than they should’ve. ",
      "Our driver didn’t speak english well. He kept urging us out of the entirely metal, lightning-rod of a tuk-tuk to start tubing. Every time we asked if it was safe to tube in the storm, he would shake is head and say no. Eventually we realized his response to almost any question was “no,” and later walked away without explanation for 10 minutes, leaving us worried we were stranded in the storm. This left half of us standing outside in the storm, scared that the tuk-tuk was a glorified lightning-rod. One guy stacked a half-dozen tubes on himself for protection.",
      "It seemed impossible to communicate that most of us wanted to go back, but after a while our fearless leader, Kira, decided to say fuck it and go tubing. That lead to all of us tagging along, and no one or their tubes (with metal rods off the side) got struck by lightning. I also now know the answer to the question “If your friend jumped off a cliff, would you too?”",
      "The sky cleared up after a little while, and we ended up having a great time. Our group was great, in spite of the sometimes overly-sexual locals and their jokes about past drownees.",
      "The alcohol is still mostly free. Every time we asked for a free shot, we got one. One bar had a zip-line that went into the river. Don’t get me wrong, the zip-line was awesome, but I ended up with a cut down my big toe (which I still can’t seem to bend fully), and fearless-leader Kira had to get stitches. I have zero regrets. "
    ],
    location: {
      name: "Tubing",
      coordinates: {
        lat: 18.961527,
        lng: 102.442545
      }
    }
  }
];

export default function Laos() {
  return <InteractiveMapPage events={events} countryName="Laos" />;
}
